var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7522 23.4241H24.0625",
    stroke: "#b3b3b3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6438 4.3482C15.5325 3.28601 17.1302 3.13025 18.2144 4.00094C18.2744 4.04818 20.2004 5.54445 20.2004 5.54445C21.3915 6.26449 21.7616 7.79522 21.0253 8.96338C20.9863 9.02594 10.097 22.6468 10.097 22.6468C9.73474 23.0987 9.18481 23.3656 8.59708 23.3719L4.42696 23.4243L3.48738 19.4474C3.35576 18.8883 3.48738 18.301 3.84966 17.849L14.6438 4.3482Z",
    stroke: "#b3b3b3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6281 6.87598L18.8754 11.6737",
    stroke: "#b3b3b3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3e1c7cfdde95ea7e1dda97b7b1c03213.svg";
export { ForwardRef as ReactComponent };